import React__default from 'react';
import _s, { keyframes, css } from 'styled-components';
import useTheme from './useTheme.js';

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
const Skeleton = ({
  borderRadius,
  height,
  width
}) => {
  const [theme] = useTheme();
  const getBorderRadius = value => {
    if (!value) return undefined;
    return `${theme.borderRadius[value]}px`;
  };
  return /*#__PURE__*/React__default.createElement(Shimmer, {
    borderRadius: getBorderRadius(borderRadius),
    height: height,
    width: width
  });
};
const shimmer = keyframes(["100%{transform:translateX(100%);}"]);
const Shimmer = styled.div`
  display: inline-block;
  overflow: hidden;
  position: relative;

  ${({
  theme,
  height,
  width,
  borderRadius
}) => css(["background-color:", ";border-radius:", ";height:", ";width:", ";"], theme.shapeFills.quinary, borderRadius, height, width)}

  &::after {
    bottom: 0;
    content: '';
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transform: translateX(-100%);

    background-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0,
      rgba(255, 255, 255, 0.2) 20%,
      rgba(255, 255, 255, 0.5) 60%,
      rgba(255, 255, 255, 0)
    );
    animation: ${shimmer} 2s infinite;
  }
`;

export { Skeleton as default };
//# sourceMappingURL=Skeleton.js.map
